import { ENVS } from "@/lib/constants";
import { useSuspenseQuery } from "@tanstack/react-query";

export const useGetEnvs = () => {
  return useSuspenseQuery({
    queryKey: ["envs"],
    queryFn: async () => {
      try {
        return ENVS;
      } catch (error) {
        console.error("Failed to fetch envs:", error);
        return [];
      }
    },
  });
};
